import React from "react";
import chrome_browser from "../../../assets/images/chrome.png";
import edge_browser from "../../../assets/images/edge.png";
import firefox_browser from "../../../assets/images/firefox.png";
import opera_browser from "../../../assets/images/opera.png";
import { StyledUnsupportedBrowser } from "../../styled/unsupportedBrowser";

export default function UnsupportedBrowser() {
  return (
    <StyledUnsupportedBrowser.Center>
      <StyledUnsupportedBrowser.Root>
        <p>
          <b>Internet Explorer</b> no es compatible con <b>ml.point</b>
          <br />
          <br />
          Le sugerimos utilizar cualquiera de los siguientes navegadores:
          <br />
          <br />
        </p>
        <StyledUnsupportedBrowser.Container>
          <StyledUnsupportedBrowser.Browser>
            <img
              src={edge_browser}
              alt="Microsoft Edge"
              title="Microsoft Edge"
              width="80"
              height="80"
            />
            <div>
              <StyledUnsupportedBrowser.Link
                href="https://www.microsoft.com/es-es/edge/"
                target="_blank"
                rel="noreferrer">
                Microsoft Edge
              </StyledUnsupportedBrowser.Link>
            </div>
          </StyledUnsupportedBrowser.Browser>
          <StyledUnsupportedBrowser.Browser>
            <img
              src={chrome_browser}
              alt="Google Chrome"
              title="Google Chrome"
              width="80"
              height="80"
            />
            <div>
              <StyledUnsupportedBrowser.Link
                href="https://www.google.com/intl/es/chrome/"
                target="_blank"
                rel="noreferrer">
                Google Chrome
              </StyledUnsupportedBrowser.Link>
            </div>
          </StyledUnsupportedBrowser.Browser>
          <StyledUnsupportedBrowser.Browser>
            <img
              src={opera_browser}
              alt="Opera"
              title="Opera"
              width="80"
              height="80"
            />
            <div>
              <StyledUnsupportedBrowser.Link
                href="https://www.opera.com/es/"
                target="_blank"
                rel="noreferrer">
                Opera
              </StyledUnsupportedBrowser.Link>
            </div>
          </StyledUnsupportedBrowser.Browser>
          <StyledUnsupportedBrowser.Browser>
            <img
              src={firefox_browser}
              alt="Mozilla Firefox"
              title="Mozilla Firefox"
              width="80"
              height="80"
            />
            <div>
              <StyledUnsupportedBrowser.Link
                href="https://www.mozilla.org/es-ES/"
                target="_blank"
                rel="noreferrer">
                Mozilla Firefox
              </StyledUnsupportedBrowser.Link>
            </div>
          </StyledUnsupportedBrowser.Browser>
        </StyledUnsupportedBrowser.Container>
      </StyledUnsupportedBrowser.Root>
    </StyledUnsupportedBrowser.Center>
  );
}
